export const ALERT_TIMEOUT = 8000;
